import { render, staticRenderFns } from "./serviceSix.vue?vue&type=template&id=63dd0510&"
import script from "./serviceSix.vue?vue&type=script&lang=js&"
export * from "./serviceSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports